// extracted by mini-css-extract-plugin
export default {"card":"Card_card__zQfcO","linkCard":"Card_linkCard__v8p2P","body":"Card_body__RHED-","subtitle":"Card_subtitle__KA6uV","imgContainer":"Card_imgContainer__WolNT"};